'use client';

import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import { ChartInterestRateModelLoading } from '../ChartInterestRateModel';
import InterestRateModelSectionLayout from '../InterestRateModelSectionLayout';
import { UtilizationTableLoading } from '../UtilizationTable/states';
const InterestRateModelSectionLoading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <InterestRateModelSectionLayout utilizationTableSlot={<UtilizationTableLoading />} utilizationChartSlot={<ChartInterestRateModelLoading />} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default memo(InterestRateModelSectionLoading);